/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminGetYoutubesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetYoutubesOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchYoutubeByYoutubeIdInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchYoutubeByYoutubeIdNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchYoutubeByYoutubeIdOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchYoutubeByYoutubeIdReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateWithTargetIdInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminYoutubesApi - axios parameter creator
 * @export
 */
export const AdminYoutubesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 어드민 뷰업유튜브 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminYoutubeControllerAdminGetYoutubes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/youtubes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 뷰업유튜브 수정
         * @param {number} youtubeId 유튜브 id
         * @param {AdminPatchYoutubeByYoutubeIdReqBodyDto} adminPatchYoutubeByYoutubeIdReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminYoutubeControllerAdminPatchYoutubeByYoutubeId: async (youtubeId: number, adminPatchYoutubeByYoutubeIdReqBodyDto: AdminPatchYoutubeByYoutubeIdReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'youtubeId' is not null or undefined
            assertParamExists('adminYoutubeControllerAdminPatchYoutubeByYoutubeId', 'youtubeId', youtubeId)
            // verify required parameter 'adminPatchYoutubeByYoutubeIdReqBodyDto' is not null or undefined
            assertParamExists('adminYoutubeControllerAdminPatchYoutubeByYoutubeId', 'adminPatchYoutubeByYoutubeIdReqBodyDto', adminPatchYoutubeByYoutubeIdReqBodyDto)
            const localVarPath = `/admin/youtubes/{youtubeId}`
                .replace(`{${"youtubeId"}}`, encodeURIComponent(String(youtubeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchYoutubeByYoutubeIdReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminYoutubesApi - functional programming interface
 * @export
 */
export const AdminYoutubesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminYoutubesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 어드민 뷰업유튜브 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminYoutubeControllerAdminGetYoutubes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetYoutubesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminYoutubeControllerAdminGetYoutubes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminYoutubesApi.adminYoutubeControllerAdminGetYoutubes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 뷰업유튜브 수정
         * @param {number} youtubeId 유튜브 id
         * @param {AdminPatchYoutubeByYoutubeIdReqBodyDto} adminPatchYoutubeByYoutubeIdReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminYoutubeControllerAdminPatchYoutubeByYoutubeId(youtubeId: number, adminPatchYoutubeByYoutubeIdReqBodyDto: AdminPatchYoutubeByYoutubeIdReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchYoutubeByYoutubeIdOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminYoutubeControllerAdminPatchYoutubeByYoutubeId(youtubeId, adminPatchYoutubeByYoutubeIdReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminYoutubesApi.adminYoutubeControllerAdminPatchYoutubeByYoutubeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminYoutubesApi - factory interface
 * @export
 */
export const AdminYoutubesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminYoutubesApiFp(configuration)
    return {
        /**
         * 
         * @summary 어드민 뷰업유튜브 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminYoutubeControllerAdminGetYoutubes(options?: RawAxiosRequestConfig): AxiosPromise<AdminGetYoutubesOkDto> {
            return localVarFp.adminYoutubeControllerAdminGetYoutubes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 뷰업유튜브 수정
         * @param {AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminYoutubeControllerAdminPatchYoutubeByYoutubeId(requestParameters: AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchYoutubeByYoutubeIdOkDto> {
            return localVarFp.adminYoutubeControllerAdminPatchYoutubeByYoutubeId(requestParameters.youtubeId, requestParameters.adminPatchYoutubeByYoutubeIdReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminYoutubeControllerAdminPatchYoutubeByYoutubeId operation in AdminYoutubesApi.
 * @export
 * @interface AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeIdRequest
 */
export interface AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeIdRequest {
    /**
     * 유튜브 id
     * @type {number}
     * @memberof AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeId
     */
    readonly youtubeId: number

    /**
     * 
     * @type {AdminPatchYoutubeByYoutubeIdReqBodyDto}
     * @memberof AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeId
     */
    readonly adminPatchYoutubeByYoutubeIdReqBodyDto: AdminPatchYoutubeByYoutubeIdReqBodyDto
}

/**
 * AdminYoutubesApi - object-oriented interface
 * @export
 * @class AdminYoutubesApi
 * @extends {BaseAPI}
 */
export class AdminYoutubesApi extends BaseAPI {
    /**
     * 
     * @summary 어드민 뷰업유튜브 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminYoutubesApi
     */
    public adminYoutubeControllerAdminGetYoutubes(options?: RawAxiosRequestConfig) {
        return AdminYoutubesApiFp(this.configuration).adminYoutubeControllerAdminGetYoutubes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 뷰업유튜브 수정
     * @param {AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminYoutubesApi
     */
    public adminYoutubeControllerAdminPatchYoutubeByYoutubeId(requestParameters: AdminYoutubesApiAdminYoutubeControllerAdminPatchYoutubeByYoutubeIdRequest, options?: RawAxiosRequestConfig) {
        return AdminYoutubesApiFp(this.configuration).adminYoutubeControllerAdminPatchYoutubeByYoutubeId(requestParameters.youtubeId, requestParameters.adminPatchYoutubeByYoutubeIdReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

